import React from "react";
import Icon from "assets/icons";
import { PurchaseTicketStep } from "./util";
import { PurchaseTicketArgsType } from "./type";
import usePurchaseTicketService from "./service";
import { useCopies } from "shared/hooks/useCopies";
import Button from "../../../../shared/components/button";
import HaveCouponCodeForm from "./components/haveCouponCodeForm";
import TicketPurchaseRegForm from "./components/ticketPurchaseRegForm";
import TicketPurchaseConfirmation from "./components/ticketPurchaseConfirmation";
import { PurchaseOrderDetails } from "shared/components/purchaseOrder";
import TicketStatus from "../../../../shared/enums/TicketStatus";
import Slider from "../../../../shared/components/slider";
import PaymentComponentWrapper from "../../../../shared/components/paymentWrapper";
import { useRegDetail } from "shared/context/regDetail";
import { getStripeReturnUrlForMyExp } from "apps/myExperience/utils";
import ApiPurchaseOrder from "../../../../shared/model/ApiPurchaseOrder";
import { ApiAmount } from "../../../../shared/types/ApiAmount";

export default function PurchaseTicket(props: PurchaseTicketArgsType) {
  const copies = useCopies();
  const { showCardIcons, invoicePaymentEnabled } = useRegDetail();
  const service = usePurchaseTicketService(props);

  if (!service.state.participantData) {
    return null;
  }
  return (
    <React.Fragment>
      <Slider
        handleClose={service.ticketStatus !== TicketStatus.COMPLETED ? props.dismissPurchaseTicketHandler : undefined}
        title={copies.get("get.ticket")}
        className="buyTicketSlider">
        {service.state.stepNo === PurchaseTicketStep.SHOW_COUPON_CODE_FORM && (
          <HaveCouponCodeForm
            state={service.state}
            dispatcher={service.dispatcher}
            successHandler={service.couponCodeSuccessHandler}
            couponCodeFormValues={service.state.couponCodeFormValues}
            openAssignTicketToSelfHandler={props.openAssignTicketToSelfHandler}
          />
        )}
        {service.state.stepNo === PurchaseTicketStep.SHOW_REG_FORM && (
          <TicketPurchaseRegForm
            state={service.state}
            onSuccessHandler={service.initiateRegSuccessHandler}
            backClickHandler={() => {
              service.state.stepNo &&
                service.state.stepNo > 0 &&
                service.dispatcher.updateStep(service.state.stepNo - 1);
            }}
            openAssignTicketToSelfHandler={props.openAssignTicketToSelfHandler}
          />
        )}
        {service.state.stepNo === PurchaseTicketStep.SHOW_PAYMENT_FORM && service.state.participantData && (
          <div className="buyTicket_wrapper">
            {!service.isInvoiceOrOfflinePaymentPending && (
              <div className="buyInventory_goBack">
                <Button
                  label={copies.get("back")}
                  icon={<Icon.ArrowBack />}
                  onClick={() => {
                    service.dispatcher.updateStep(1);
                  }}
                />
              </div>
            )}
            <div className="purchaseTicketPayment">
              <PurchaseOrderDetails
                purchaseOrder={service.state.participantData?.regPurchaseOrder as ApiPurchaseOrder}
                originatingFormName={service.state.participantData?.registrationForm?.title}
              />
              <PaymentComponentWrapper
                purchaseOrderId={service.state.participantData?.regPurchaseOrder?.purchaseOrderId as string}
                amount={service.state.participantData.regPurchaseOrder?.amount as ApiAmount}
                registrationParticipantId={service.state.participantData.id}
                successHandler={service.paymentSuccessHandler}
                errorHandler={service.paymentErrorHandler}
                showCardIcons={showCardIcons}
                onAmountMismatch={service.paymentMismatchHandler}
                invoicePaymentEnabled={invoicePaymentEnabled}
                invoicePaymentConfig={{
                  initialEmail: service.invoicePaymentRequest.invoicePayerEmail
                }}
                invoicePayerId={service.state.participantData?.regPurchaseOrder?.invoicePaymentRequest?.invoicePayerId}
                invoicePaymentRequestId={
                  service.state.participantData?.regPurchaseOrder?.invoicePaymentRequest?.invoicePaymentRequestId
                }
                invoicePayerPaymentRequestSuccessHandler={service.invoicePayerPaymentRequestSuccessHandler}
                resendInvoicePaymentReminderSuccessHandler={service.resendInvoicePaymentReminderSuccessHandler}
                stripeReturnUrl={getStripeReturnUrlForMyExp({
                  registrationParticipantId: service.state.participantData.id,
                  purchaseOrderId: service.state.participantData?.regPurchaseOrder?.purchaseOrderId as string
                })}
                offlinePaymentConfig={{
                  offlinePaymentRequested: service.state.participantData.regPurchaseOrder?.hasRequestedOfflinePayment,
                  paymentReferenceId: service.state.participantData.regPurchaseOrder?.transaction?.providerPaymentId
                }}
                offlineTransactionUpdateSuccessHandler={service.offlineTransactionUpdateSuccessHandler}
                offlineTransactionCancelSuccessHandler={service.offlineTransactionCancelSuccessHandler}
              />
            </div>
          </div>
        )}
        {service.state.stepNo === PurchaseTicketStep.SHOW_CONFIRMATION_VIEW && (
          <TicketPurchaseConfirmation
            state={service.state}
            dismissPurchaseTicketHandler={() => {
              props.dismissPurchaseTicketHandler?.();
            }}
          />
        )}
      </Slider>
    </React.Fragment>
  );
}
